import { bookDetailsActionTypes } from './Constants';

export function getBookDetailsRequest(id) {
	return {
		type: bookDetailsActionTypes.GET_BOOK_DETAILS_REQUEST,
		payload: {
			id,
		},
	};
}

export function getBookDetailsSuccess(data) {
	return {
		type: bookDetailsActionTypes.GET_BOOK_DETAILS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getBookDetailsError(error) {
	return {
		type: bookDetailsActionTypes.GET_BOOK_DETAILS_ERROR,
		payload: {
			error,
		},
	};
}

export function addToMyBooksRequest(bookId, name, callback) {
	return {
		type: bookDetailsActionTypes.ADD_TO_MY_BOOKS_REQUEST,
		payload: {
			bookId,
			name,
			callback,
		},
	};
}

export function addToMyBooksSuccess(data) {
	return {
		type: bookDetailsActionTypes.ADD_TO_MY_BOOKS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function addToMyBooksError() {
	return {
		type: bookDetailsActionTypes.ADD_TO_MY_BOOKS_ERROR,
	};
}

export function removeFromMyBooksRequest(bookId, name, callback) {
	return {
		type: bookDetailsActionTypes.REMOVE_FROM_MY_BOOKS_REQUEST,
		payload: {
			bookId,
			name,
			callback,
		},
	};
}

export function removeFromMyBooksSuccess(data) {
	return {
		type: bookDetailsActionTypes.REMOVE_FROM_MY_BOOKS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function removeFromMyBooksError() {
	return {
		type: bookDetailsActionTypes.REMOVE_FROM_MY_BOOKS_ERROR,
	};
}

export function clearBooksDetails() {
	return {
		type: bookDetailsActionTypes.CLEAR_BOOKS_DETAILS,
	};
}
